<template>
  <section class="school-banner">
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <!-- 轮播项1 -->
       
        <div class="swiper-slide" v-for="(val,index) in swiperList" :key="index">
          <div class="banner-overlay">
            <img class="big-tu" v-if="imageLoaded" :src="val.pic" alt="" @click="swiperGo(val)">
           
            <div class="philosophy-box">
              <p class="philosophy-text">{{ val.title }} </p>
               <!-- <p>{{ val.pic }}</p> -->
            </div>
          </div>
        </div>
     
       
      </div>
      
      <!-- 分页器 -->
      <div class="swiper-pagination"></div>
      
      <!-- 导航按钮 -->
      <div class="swiper-button-next">
        <div class="arrow-icon"></div>
      </div>
      <div class="swiper-button-prev">
        <div class="arrow-icon"></div>
      </div>
      
    </div>
  </section>
</template>

<script>
import { Swiper } from 'swiper'
import { homeApi } from '@/api'
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/effect-fade'

export default {
  name: 'SchoolBanner',
  data() {
    return {
      swiper: null, // Swiper实例
      swiperList:[],
      imageLoaded:false
    }
  },
 
  async mounted() {
    // 先获取数据
    await this.getSwiperList();
    
    // 数据加载完成后再初始化Swiper
    if (this.swiperList.length > 0) {
      this.initSwiper();
    }
  },
  beforeDestroy() {
    // 销毁Swiper实例
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  },
  methods:{
    // 初始化Swiper
    initSwiper() {
      this.swiper = new Swiper('.swiper-container', {
        modules: [Navigation, Pagination, Autoplay, EffectFade],
        loop: this.swiperList.length > 1, // 只有多张图片时才循环
        autoplay: this.swiperList.length > 1 ? {
          delay: 5000,
          disableOnInteraction: false,
        } : false, // 只有多张图片时才自动播放
        // 提升点击响应：避免 Swiper 阻止点击、开启观察者、提升阈值
        preventClicks: false,
        preventClicksPropagation: false,
        threshold: 3,
        observer: true,
        observeParents: true,
        watchOverflow: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          bulletClass: 'swiper-pagination-bullet',
          bulletActiveClass: 'swiper-pagination-bullet-active',
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        speed: 100,
      });
    },
    //获取导航列表数据
    async getSwiperList(){
      try {
        let params = {}
        
        const response = await homeApi.getSwiperList(params)
      
        if (response && response.code === 0) {
          this.swiperList = response.data;
          this.imageLoaded = true;
          // 处理成功响应
          console.log('获取轮播图数据成功:', response.data)
        } else {
          console.error('获取轮播图数据失败:', response)
           this.swiperList = [];
        }
      } catch (error) {
        console.error('获取轮播图数据异常:', error)
      }
    },
    swiperGo(val){
      //有文章跳转到文章id 
      if(val.articleId){
        this.$router.push({
          path:'/article',
          query:{
            id:val.articleId
          }
        })
       
      }else if(val.navSubId){//跳转到对应的二级导航页面
        let data =JSON.parse(sessionStorage.getItem('navList')) ;
        console.log('data',data)
        let query = {
            categoryId: '',
            sectionId:val.navSubId,
            categoryTitle: '',
            sectionTitle: ''
        }
     
        data.forEach(item => {
          //console.log(item)
          if(item.children && item.children.length > 0){
            const matchedChild = item.children.find(child => child.id == val.navSubId);
            console.log('matchedChild',matchedChild)
            if(matchedChild) {
           
              query.categoryId = item.id;
              query.categoryTitle = item.title;
              query.sectionTitle = matchedChild.title
            }
          }
        });

     
        this.$router.push({
          path: '/categoryMore',
          query:query
        })
        
      }
    }
  }
}
</script>

<style scoped>
.school-banner {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.swiper-container {
  height: 394px;
  width: 100%;
}

.swiper-slide {
  position: relative;
  height: 394px;
  display: flex;
  align-items: center;
  justify-content: center;
}


.banner-overlay {
  position: relative;
  width: 100%;
  height: 100%;
}

.big-tu {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}



.philosophy-box {
  background: rgba(0, 0, 0, 0.5);
  padding: 10px 20px;
  border-radius: 12px;
 
  border: 1px solid rgba(255, 255, 255, 0.2);
  max-width: 800px;
  animation: fadeInUp 1s ease-out 0.3s both;
  position: absolute;
  bottom: 50px;
  left:80px;
}

.philosophy-title {
  color: #ffd700;
  font-size: 1.8rem;
  font-weight: bold;
  margin-bottom: 15px;
  text-align: center;
}

.philosophy-text {
  color: #fff;
  font-size: 1.2rem;
  line-height: 1.8;
  text-align: center;
  margin: 0;
}

/* Swiper 导航按钮样式 */
.swiper-button-next,
.swiper-button-prev {
  color: #fff !important;
  background: linear-gradient(135deg, rgba(30, 60, 114, 0.95), rgba(30, 60, 114, 0.8));
  border-radius: 50%;
  width: 40px !important;
  height: 40px !important;
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  border: 3px solid rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(15px);
  box-shadow: 
    0 10px 40px rgba(0, 0, 0, 0.4),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
  position: absolute !important;
  overflow: hidden !important;
  cursor: pointer;
  z-index: 1002 !important; /* 高于下拉菜单 1000 */
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

/* 按钮内部光效 */
.swiper-button-next::before,
.swiper-button-prev::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.15) 50%, transparent 70%);
  transform: translateX(-100%);
  transition: transform 0.8s ease;
  border-radius: 50%;
  z-index: 1;
}

/* 自定义箭头图标样式 */
.arrow-icon {
  font-size: 16px !important;
  font-weight: 600 !important;
  color: #fff !important;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.4) !important;
  transition: all 0.4s ease !important;
  display: block !important;
  line-height: 1 !important;
  position: relative !important;
  z-index: 2 !important;
}

/* 悬停效果 */
.swiper-button-next:hover,
.swiper-button-prev:hover {
  background: linear-gradient(135deg, rgba(30, 60, 114, 1), rgba(30, 60, 114, 0.9));
  transform: scale(1.15) translateY(-2px);
  box-shadow: 
    0 15px 50px rgba(30, 60, 114, 0.5),
    inset 0 1px 0 rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.6);
}

.swiper-button-next:hover::before,
.swiper-button-prev:hover::before {
  transform: translateX(100%);
}


/* 点击效果 */
.swiper-button-next:active,
.swiper-button-prev:active {
  transform: scale(1.1) translateY(-1px);
  box-shadow: 
    0 8px 30px rgba(30, 60, 114, 0.4),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
  transition: all 0.1s ease;
}


.swiper-button-next:hover .arrow-icon,
.swiper-button-prev:hover .arrow-icon {
  transform: scale(1.1) !important;
  text-shadow: 0 5px 10px rgba(0, 0, 0, 0.5) !important;
  color: #fff !important;
}

/* 左右按钮特殊定位 */
.swiper-button-next {
  right: 20px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
}

.swiper-button-prev {
  left: 20px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
}

/* 按钮禁用状态 */
.swiper-button-disabled {
  opacity: 0.3 !important;
  cursor: not-allowed !important;
  transform: scale(0.9) !important;
}

.swiper-button-disabled:hover {
  transform: scale(0.9) !important;
  background: linear-gradient(135deg, rgba(30, 60, 114, 0.5), rgba(30, 60, 114, 0.3)) !important;
}

/* Swiper 分页器样式 */
.swiper-pagination {
  bottom: 30px !important;
  z-index: 10 !important;
}

.swiper-pagination-bullet {
  background: #ffffff !important;
  opacity: 1 !important;
  width: 10px !important;
  height: 10px !important;
  margin: 0 8px !important;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 50% !important;
  border: 3px solid #ffffff !important;
  backdrop-filter: blur(5px);
  position: relative;
  overflow: hidden;
  display: inline-block !important;
}

.swiper-pagination-bullet::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  transform: translate(-50%, -50%);
  transition: all 0.3s ease;
}

.swiper-pagination-bullet:hover {
  background: #ffffff !important;
  transform: scale(1.2) !important;
  border-color: #ffffff !important;
  box-shadow: 0 4px 12px rgba(255, 255, 255, 0.8) !important;
}

.swiper-pagination-bullet:hover::before {
  width: 100%;
  height: 100%;
}

.swiper-pagination-bullet-active {
  background: #2d1cb0 !important;
  transform: scale(1.4) !important;
  border-color: #2d1cb0 !important;
  box-shadow: 0 6px 20px rgba(45, 28, 176, 0.9) !important;
}

.swiper-pagination-bullet-active::before {
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.3) !important;
}

/* 动画效果 */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .swiper-container {
    height: 400px;
  }
  
  .swiper-slide {
    height: 400px;
  }
  
  .banner-title {
    font-size: 2.5rem;
  }
 
  
  .philosophy-box {
    padding: 20px 30px;
    max-width: 90%;
  }
  
  .philosophy-title {
    font-size: 1.5rem;
  }
  
  .philosophy-text {
    font-size: 1rem;
  }
  
  .swiper-button-next,
  .swiper-button-prev {
    width: 60px !important;
    height: 60px !important;
    margin-top: -30px !important;
  }
  
  .swiper-button-next:after,
  .swiper-button-prev:after {
    font-size: 24px !important;
  }
  
  .swiper-button-next {
    right: 15px !important;
  }
  
  .swiper-button-prev {
    left: 15px !important;
  }
  
  .swiper-pagination-bullet {
    width: 12px !important;
    height: 12px !important;
    margin: 0 6px !important;
    background: #fff !important;
  }
  
  .swiper-pagination {
    bottom: 25px !important;
  }
}




</style>

<!-- 非scoped样式，确保覆盖Swiper默认样式 -->
<style>
.school-banner .swiper-pagination-bullet {
  background: #ffffff !important;
  opacity: 1 !important;
  width: 10px !important;
  height: 10px !important;
  margin: 0 8px !important;
  border-radius: 50% !important;

  display: inline-block !important;
}

.school-banner .swiper-pagination-bullet:hover {
  background: #ffffff !important;
  transform: scale(1.2) !important;
  box-shadow: 0 4px 12px rgba(255, 255, 255, 0.8) !important;
}

.school-banner .swiper-pagination-bullet-active {
  background: #2d1cb0 !important;
  transform: scale(1.4) !important;
  border-color: #2d1cb0 !important;
  box-shadow: 0 6px 20px rgba(45, 28, 176, 0.9) !important;
}

.school-banner .swiper-pagination {
  bottom: 30px !important;
  z-index: 10 !important;
}

/* 当下拉菜单激活时，隐藏轮播图按钮 */
.dropdown-menu-active .school-banner .swiper-button-next,
.dropdown-menu-active .school-banner .swiper-button-prev {
  display: none !important;
  visibility: hidden !important;
  opacity: 0 !important;
  pointer-events: none !important;
}
</style>

